import React, { useEffect, useRef, useState } from "react"
import InfiniteScroll from "react-infinite-scroll-component"
import { useHistory } from "react-router-dom"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { getFoods } from "services"
import { isSimpleFood, refactorFoods } from "utils"
import { InfiniteScrollLoading, Navbar, PageLoader } from "components"
import InventorySearch from "./InventorySearch"
import InventoryTableHeader from "./InventoryTableHeader"
import InventoryRowVariants from "./InventoryRowVariants"
import InventoryTableSimpleRow from "./InventoryTableSimpleRow"
import classes from "./index.module.scss"

const limit = 30

const Inventory = () => {
  const [t] = useTranslation()

  const history = useHistory()

  const branchId =
    useSelector(state => state.userAccountInfo.branchId)

  const [foods, setFoods] = useState(null)
  const [search, setSearch] = useState("")
  const [skip, setSkip] = useState(0)
  const [hasMore, setHasMore] = useState(true)

  const unmount = useRef(false)

  const handleLoadMore = async () => {
    try {
      const response =
        await getFoods({
          limit,
          skip,
          branchId,
          search
        })

      if (unmount.current) return

      response.length !== limit
        ? setHasMore(false)
        : setSkip(prev => prev += limit)

      const refactoredFoods =
        refactorFoods(response, branchId)

      setFoods(prev => ([
        ...prev,
        ...refactoredFoods
      ]))
    } catch (err) {
      console.log(err)
    }
  }

  const getFoodsList = async () => {
    if (foods !== null) {
      setSkip(0)
      setFoods(null)
      setHasMore(true)
    }

    try {
      const response =
        await getFoods({
          skip: 0,
          limit,
          branchId,
          search
        })

      if (unmount.current) return

      response.length !== limit
        ? setHasMore(false)
        : setSkip(prev => prev += limit)

      const refactoredFoods =
        refactorFoods(response, branchId)

      setFoods(refactoredFoods)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getFoodsList()
  }, [search])

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  return (
    <div className={classes["container"]}>
      <Navbar
        title={t("فهرست_موجودی")}
        variant="compact"
        onLeftIconPress={() => history.push("settings")}
      />
      <InventorySearch
        onSearch={(value) => setSearch(value)}
      />
      {foods !== null
        ?
        <div
          id="scrollable-div"
          className={classes["scrollable"]}
        >
          <InfiniteScroll
            hasMore={hasMore}
            dataLength={skip}
            next={handleLoadMore}
            style={{ overflow: "unset" }}
            scrollableTarget="scrollable-div"
            loader={<InfiniteScrollLoading />}
            scrollThreshold="100px"
          >
            <table className={classes["table"]}>
              <InventoryTableHeader />
              <tbody>
                {foods.map(food =>
                  isSimpleFood(food.options)
                    ?
                    <InventoryTableSimpleRow
                      key={food._id}
                      food={food}
                    />
                    :
                    <InventoryRowVariants
                      key={food._id}
                      food={food}
                    />
                )}
              </tbody>
            </table>
          </InfiniteScroll>
        </div>
        :
        <div className={classes["loading"]}>
          <PageLoader />
        </div>
      }
    </div>

  )
}

export default Inventory